import { TBanksItemData } from "../store/reducers/countriesSlice";

export const parseStringArrayToOptions = (array: string[]) => {
  return array.map(item => ({ value: item, label: item }));
}

export const parseBanksArrayToOptions = (array: TBanksItemData[]) => {
  return array.map(item => ({ value: item.bankId.toString(), label: item.name }));
}